module.exports = __webpack_public_path__ + "img/snelterecht-logo.85dfac4b.png";